export const SET_GNB = 'SET_GNB';

export const setGnb = (list) => {
  return {
    type: SET_GNB,
    list,
  };
};
